firebird.directive('meetingAssistant', [
    'templateCache',
    function (templateCache) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate('meeting_assistant/templates/meetingAssistant.html'),
            controller: 'meetingAssistantCtrl',
            controllerAs: 'assistant'
        };
    }
]);
